import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/bank/importer/bankImporterActions'

export default importerReducers(actions)
